import RankFour from '@assets/icons/rank-four.svg'
import { Icon } from './Icon'

export const RankFourIcon = Icon(RankFour)
